import { render, staticRenderFns } from "./EditPlugin.vue?vue&type=template&id=3c9d8fd0&"
import script from "./EditPlugin.vue?vue&type=script&lang=js&"
export * from "./EditPlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports